import styled from 'styled-components';
import {dFlexColumn, alignCenter} from '../../../../globalVariables/GlobalFlex';

export const transactionTop = styled.div`
    ${dFlexColumn}
    ${alignCenter}
    gap: var(--space-xs);
    padding: var(--space-sm) var(--space-md);
`;

export const transactionTopTitle = styled.span`
    font-size: var(--font-size-h3);
    font-weight: var(--font-weight-bold);
`;

export const orderNumber = styled.span`
    font-size: var(--font-size-body-small);
    color: var(--color-text-default);
`;
